module.exports = __webpack_public_path__ + "img/qrcode.b79c5a64.jpg";